import { Component } from 'react';
import React from "react";
import Button from 'react-bootstrap/Button';
import ViewDetailModal from './ViewDetailModal';
import AddCommentModal from './AddCommentModal';
import ConfirmationModal from '../UserManagement/ConfirmationModal';
import TagScanModal from './TagScanModal';
import Form from 'react-bootstrap/Form';
import UploadImg from "../../src/components/images/cloud-computing.svg";
import EditImg from "../../src/components/images/edit.svg";
import ViewImg from "../../src/components/images/icon-viewID.svg";
import DownloadImg from "../../src/components/images/download-cloud.svg";
import poweredByImg from "../../src/components/images/logo_transparent_blue.png";
import './FetchData.css';
import BootstrapTable from 'react-bootstrap-table-next';
import $ from 'jquery';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { FilePicker } from 'react-file-picker';
import authService from '../../src/components/api-authorization/AuthorizeService';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import moment from "moment"
import packageJson from '../../package.json';
import { DateRangePicker } from 'rsuite'
import 'rsuite/dist/styles/rsuite-default.css'
import { ToggleButton } from './toggleButton'
import '../scantaggerJS.css'
import CollapsibleList from './collapsibleList'
import { TimeOutNotification } from "../UserManagement/TimeOutNotification";
import { SessionTimeout } from "../SessionTimeoutSettings";
export class ScanTaggerTableView extends Component {
    static displayName = "Transfer Website";
    async componentDidMount() {
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keydown', this.handleActivity);
        window.addEventListener('scroll', this.handleActivity);

        var bUrl = window.location.href;
        if (bUrl.includes('/scan/')) {
            var scandtoId = bUrl.split(/scan\/(.*)/)[1];
            window.localStorage.setItem('scandtoId', scandtoId);
            const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);

            this.setState({
                isAuthenticated,
                userName: user && user.name,
                scanDtoIdEmailRequest: true
            });
            this.getScanBasedonScanDtoId();
        }
        else {
            this.populateState();
        }
    }
    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keydown', this.handleActivity);
        window.removeEventListener('scroll', this.handleActivity);
    }
    startSessionTimeoutCounter() {
        this.setState({
            expireMins: parseInt(window.localStorage.getItem('ExpireMinutes')),
            sesExpNotMins: parseInt(window.localStorage.getItem('SessionExpireNotificationMinutes'))
        });

        window['startNotificationCounter'](this.state.expireMins, this.state.sesExpNotMins);
    }
    handleActivity = () => {
        window['resetCountersOnEvent'](this.state.expireMins, this.state.sesExpNotMins);
    };

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            userName: null, scandata: [], filterdata: [], Id: '', viewall: "none", scanDtoIdEmailRequest: false, loading: true, show: false, showSaveCommentbutton: true, showTagCommentModal: false, showaddcommentmodal: false, showconfirmationmodal: false, showundiscardconfirmationmodal: false, showviewdetailmodal: false, fileObject: '', comments: '', scanDto: [], filestream: [], tagcheck: true, untagcheck: true, discardedcheck: false, activecheck: true, IdstudyTimepointData: '',
            studyNameLookup: {}, value: [new Date(moment().subtract(6, 'months')), new Date()], byCreated: true, checkboxSelection: [], selectedRow: null,
            expireMins: 0,
            sesExpNotMins: 0,
            marginTop: "160px",
        };
        this.handleClose = this.handleClose.bind(this);
        this.populateState = this.populateState.bind(this);
        this.handleShowCommentModal = this.handleShowCommentModal.bind(this);
        this.handleShowConfirmationModal = this.handleShowConfirmationModal.bind(this);
        this.handleShowUndiscardConfirmationModal = this.handleShowUndiscardConfirmationModal.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.UpdateComments = this.UpdateComments.bind(this);
        this.UpdateStudiesTimepoints = this.UpdateStudiesTimepoints.bind(this);
        this.Download = this.Download.bind(this);
        this.handleTagCheck = this.handleTagCheck.bind(this);
        this.handleUntagCheck = this.handleUntagCheck.bind(this);
        this.filterDataBasedOnCheckboxes = this.filterDataBasedOnCheckboxes.bind(this);
        this.DiscardScans = this.DiscardScans.bind(this);
        this.UnDiscardScans = this.UnDiscardScans.bind(this);
        this.ViewAllScans = this.ViewAllScans.bind(this);
        this.startSessionTimeoutCounter = this.startSessionTimeoutCounter.bind(this);
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name
        }, () => this.getAllScans());
    }
    ViewAllScans() {
        var origin = window.origin;
        window.location.href = origin;
    }
    handleClose() {
        this.setState({
            show: false,
            showTagCommentModal: false,
            showaddcommentmodal: false,
            showconfirmationmodal: false,
            showundiscardconfirmationmodal: false,
            showviewdetailmodal: false
        }, () =>
            console.log(this.state));
    }
    handleViewDetailModal = (row) => {
        this.setState({
            showviewdetailmodal: true,
            scanDto: row
        })
    }
    handleShowCommentModal(row) {
        this.setState({
            showaddcommentmodal: true,
            scanDto: row,
            comments: row.comments
        }, () =>
            console.log(this.state));
    }
    handleStudiesAndTimepointsFormat = (row) => {
        const studyTimePointKeyValue = Object.entries(row.studyTimepointLookup).map(([key, value]) => [this.state.studyNameLookup[key], value]);
        return studyTimePointKeyValue.toString()
    }

    handleShowConfirmationModal(row) {
        this.setState({
            showconfirmationmodal: true,
            modalName: 'discardScanConfirmModal',
        }, () =>
            console.log(this.state));
    }
    handleShowUndiscardConfirmationModal(row) {
        this.setState({
            showundiscardconfirmationmodal: true,
            modalName: 'UndiscardScanConfirmModal',
        }, () =>
            console.log(this.state));
    }

    handleShow(row) {
        this.setState({
            showTagCommentModal: true,
            scanDto: row, userName: this.state.userName
        }, () =>
            console.log(this.state));
    }
    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    handleUntagCheck(checkOption) {
        this.setState({
            untagcheck: checkOption
        }, () => {
            this.filterDataBasedOnCheckboxes();
        });
    }
    handleTagCheck(checkOption) {
        this.setState({
            tagcheck: checkOption
        }, () =>
            this.filterDataBasedOnCheckboxes());
    }
    handleActiveCheck(checkOption) {
        this.setState({
            activecheck: checkOption
        }, () => {
            this.filterDataBasedOnCheckboxes();
        });
    }
    handleDiscardCheck(checkOption) {
        this.setState({
            discardedcheck: checkOption
        }, () =>
            this.filterDataBasedOnCheckboxes());
    }
    handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                checkboxSelection: [...this.state.checkboxSelection, row.id]
            }));
        } else {
            this.setState(() => ({
                checkboxSelection: this.state.checkboxSelection.filter(x => x !== row.id)
            }));
        }
    }
    handleOnSelectAll = (isSelect, rows) => {
        const ids = rows.map(r => r.id);
        if (isSelect) {
            this.setState(() => ({
                checkboxSelection: ids
            }));
        } else {
            this.setState(() => ({
                checkboxSelection: []
            }));
        }
    }
    setRow(row) {
        this.setState(() => ({
            selectedRow: row
        }));
    }
    filterDataBasedOnCheckboxes() {
        var tagCheckbox = this.state.tagcheck;
        var unTagCheckbox = this.state.untagcheck;
        var discardedCheckbox = this.state.discardedcheck;
        var activeCheckbox = this.state.activecheck;
        var filterActivedata = []; var filterDiscarddata = []
        var scandata = this.state.scandata;

        //Active Scan data display
        //By Default case
        if (activeCheckbox === true && unTagCheckbox === true && tagCheckbox === false) {
            let data = scandata.filter(function (e) {
                return e.discarded === false && e.studyTimepointLookup === null;
            });
            filterActivedata.push(data);
        }
        else if (activeCheckbox === true && unTagCheckbox === false && tagCheckbox === true) {
            let data = scandata.filter(function (e) {
                return e.discarded === false && e.studyTimepointLookup !== null;
            });
            filterActivedata.push(data);
        }
        else if (activeCheckbox === true && unTagCheckbox === true && tagCheckbox === true) {
            let data = scandata.filter(function (e) {
                return e.discarded === false;
            });
            filterActivedata.push(data);
        }

        //Discard Scan data display
        if (discardedCheckbox === true && unTagCheckbox === true && tagCheckbox === true) {
            let data = scandata.filter(function (e) {
                return e.discarded === true;
            });
            filterDiscarddata.push(data);
        }
        else if (discardedCheckbox === true && unTagCheckbox === true && tagCheckbox === false) {
            let data = scandata.filter(function (e) {
                return e.discarded === true && e.studyTimepointLookup == null;
            });
            filterDiscarddata.push(data);
        }
        else if (discardedCheckbox === true && unTagCheckbox === false && tagCheckbox === true) {
            let data = scandata.filter(function (e) {
                return e.discarded === true && e.studyTimepointLookup !== null;
            });
            filterDiscarddata.push(data);
        }

        //Getting combined Result
        var combinedResult = [];
        if (filterActivedata.length > 0 && filterDiscarddata.length > 0) {
            combinedResult = filterActivedata[0].concat(filterDiscarddata[0]);
        }
        else if (filterActivedata.length <= 0 && filterDiscarddata.length > 0) {
            combinedResult = filterDiscarddata[0];
        }
        else if (filterActivedata.length > 0 && filterDiscarddata.length <= 0) {
            combinedResult = filterActivedata[0];
        }

        this.setState({
            filterdata: combinedResult
        });
    }
    updateExamForm(file) {
        this.setState({
            fileObject: file.target.files[0],
            scanDto: this.state.selectedRow
        });

        this.ConfirmUpdateExamForm(file.target.files[0], this.state.selectedRow);
    }
    Download(Id) {
        this.setState({ Id: Id }, () =>
            this.DownloadFile())
    }
    DateTimeFormatter(date) {
        var offsetInhrs = (new Date().getTimezoneOffset()) / 60;
        return moment(date).format("YYYY-MM-DD[\n]HH:mm:ss") + "+" + (-offsetInhrs);
    }

    DicomDateFormatter(date) {
        if (typeof date !== 'undefined' && date !== null)
            return date.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        else
            return date;
    }

    render() {
        const columns = [
            {
                dataField: 'id',
                text: 'Id',
                filter: textFilter({
                    placeholder: 'Search scanDtoID'
                }),
                classes: 'scanDtoID',
                hidden: false,
                style: { display: 'none' }
            },
            {
                dataField: 'patientId',
                text: 'Patient ID',
                filter: textFilter({
                    placeholder: 'Search Patient ID'
                }),
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "160px", textAlign: 'left' };
                },
                formatter: (cellContent, row) => {
                    return (<div>
                        <img src={ViewImg} style={{ marginLeft: "7px", float: "right" }} height="28px" title="View details" alt="" onClick={e => this.handleViewDetailModal(row)} />
                        {cellContent}                </div>)
                }
            },
            {
                dataField: 'creationDateTime',
                text: 'Created',
                sort: true,
                filter: textFilter({ placeholder: 'Search Created Time' }),
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", textAlign: 'left' };
                },
                formatter: (cellContent) => { return this.DateTimeFormatter(cellContent) },
                style: { wordBreak: "break-word" }
            },
            {
                dataField: 'lastModifiedDateTime',
                text: 'Updated',
                sort: true,
                filter: textFilter({ placeholder: 'Search Updated Time' }),
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", textAlign: 'left' };
                },
                formatter: (cellContent) => { return this.DateTimeFormatter(cellContent) },
                style: { wordBreak: "break-word" }
            },
            {
                dataField: 'studyDate',
                text: 'Study Date',
                filter: textFilter({
                    placeholder: 'Search Study Date'
                }),
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "130px", textAlign: 'left' };
                },
                formatter: (cellContent) => { return this.DicomDateFormatter(cellContent) }
            },
            {
                dataField: 'deviceSerialNumber',
                text: 'Device SN',
                filter: textFilter({
                    placeholder: 'Search Device Serial'
                }),
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", textAlign: 'left' };
                }
            },
            {
                dataField: 'institutionName',
                text: 'Institution',
                filter: textFilter({
                    placeholder: 'Search Institution'
                }),
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", textAlign: 'left' };
                },
                style: { wordBreak: "break-word" }
            },
            {
                dataField: 'msBaseSubStudies',
                text: 'MSBase Sub-studies',
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", textAlign: 'left' };
                },
                filter: textFilter({ placeholder: 'Search MSBase Sub-studies' }),
                formatter: (cellContent) => {
                    //return JSON.stringify(cellContent).replace(/\[|\]|"/g, '').replace(/,/g, ', ');
                    var items = JSON.stringify(cellContent).replace(/\[|\]|"/g, '').split(',');
                    if (items.length === 1 && items[0].length === 0) { return null }
                    else if (items.length === 1 && items[0].length > 0) { return items[0] }
                    else {
                        return (<CollapsibleList items={items} />
                        )
                    }
                },
                sort: true,
                style: { wordBreak: "break-word" }
            },
            {
                dataField: 'studyTimepointLookup',
                text: 'Studies/Timepoints',
                filter: textFilter({ placeholder: 'Search Studies/Timepoints' }),
                filterValue: (cellContent, row) => {
                    if (cellContent === null) {
                        return null
                    } else {
                        return this.handleStudiesAndTimepointsFormat(row)
                    }
                },
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left' };
                },
                style: { wordBreak: "break-word" },
                formatter: (cellContent, row) => {
                    if (cellContent === null) {
                        return (
                            <img src={EditImg} style={{ marginLeft: "7px", float: "right" }} height="28px" title="Tag Scan" alt="" onClick={e => this.handleShow(row)} />
                        );
                    }
                    else {
                        return <div>
                            <img src={EditImg} style={{ marginLeft: "7px", float: "right" }} height="28px" title="Tag Scan" alt="" onClick={e => this.handleShow(row)} />
                            {
                                Object.entries(row.studyTimepointLookup).sort()
                                    .map(([key, value], index) => <p key={index}><React.Fragment>{this.state.studyNameLookup[key]}{' ('}{value}{')'}</React.Fragment></p>)
                            }

                        </div>
                    };
                }
            },
            {
                dataField: 'comments',
                text: 'Comments',
                filter: textFilter({ placeholder: 'Search Comments' }),
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "170px", textAlign: 'left' };
                },
                style: { wordBreak: "break-word" },
                formatter: (cellContent, row) => {
                    if (cellContent === null) {
                        return (

                            <img src={EditImg} style={{ marginLeft: "7px", float: "right" }} height="28px" title="Add Comment" alt="" onClick={e => this.handleShowCommentModal(row)} />

                        );
                    }
                    else {
                        return <div>
                            <img src={EditImg} style={{ marginLeft: "7px", float: "right" }} height="28px" title="Edit Comment" alt="" onClick={e => this.handleShowCommentModal(row)} />
                            {cellContent}
                        </div>
                    }
                }
            },
            {
                dataField: 'examFormFileName',
                text: 'Exam Form',
                filter: textFilter({ placeholder: 'Search Exam Form' }),
                align: 'left',
                headerStyle: (colum, colIndex) => {
                    return { width: "130px", textAlign: 'left' };
                },
                formatter: (cellContent, row) => {
                    if (row.examFormFileName != null) {
                        return (
                            <div>
                                <img src={DownloadImg} height="28px" alt="" title="Download Exam Form" onClick={e => this.Download(row.id)} style={{ float: "right", marginRight: "10px" }} />
                                <div class="image-upload">
                                    <label for="file-input">
                                        <img src={UploadImg} height="28px" alt="" title="Upload Exam Form" onClick={e => this.setRow(row)} />
                                    </label>
                                    <input id="file-input" style={{ display: "none" }} type="file" accept="application/pdf,.jpg,.jpeg,.png,.gif,.svg" onChange={FileObject => this.updateExamForm(FileObject)} onError={errMsg => (alert("error occured"))} />
                                </div>
                            </div>

                        )
                    }
                    else {
                        return (
                            <div>
                                <div class="image-upload">
                                    <label for="file-input">
                                        <img src={UploadImg} height="28px" alt="" title="Upload Exam Form" />
                                    </label>
                                    <input id="file-input" style={{ display: "none" }} type="file" accept="application/pdf,image/*" onChange={FileObject => this.updateExamForm(FileObject)} onError={errMsg => (alert("error occured"))} />
                                </div>
                            </div>
                        )
                    }
                }
            }];
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: false,
            classes: 'selectCheckbox',
            selected: this.state.checkboxSelection,
            onSelect: this.handleOnSelect,
            onSelectAll: this.handleOnSelectAll
        };

        const defaultSorted = [{
            dataField: 'creationDateTime',
            order: 'desc'
        },
        {
            dataField: 'id',
            order: 'desc'
        }];
        const rowClasses = (row, rowIndex) => {
            let classes = null;
            if (rowIndex % 2 === 0) {
                classes = 'row-even';
            }
            else {
                classes = 'row-odd';
            }

            return classes;
        };

        return (

            <div >

                <div style={{ whiteSpace: "pre-wrap", display: "flex" }}>

                    <Button variant="primary" onClick={(e) => this.handleShowConfirmationModal()} style={{ marginTop: "2px", marginBottom: "2px" }} > Discard scan(s)</Button>{'   '}
                    <Button variant="primary" onClick={(e) => this.handleShowUndiscardConfirmationModal()} style={{ marginLeft: "10px", marginTop: "2px", marginBottom: "2px" }} > Restore scan(s)</Button>{'   '}
                    <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }} className="datepicker-group-wrapper">
                        <DateRangePicker
                            value={this.state.value}
                            onChange={value => {
                                this.setState({ value });
                                console.log(value);
                            }}
                        />
                        <ToggleButton
                            selected={this.state.byCreated}
                            toggleSelected={() => {
                                this.setState((prevState) => {
                                    return { byCreated: !prevState.byCreated }
                                })
                            }}
                        />
                        <Button variant="primary" id="Reload-Button" onClick={(e) => this.getAllScans()}>Reload</Button>

                    </div>

                    <Form.Check type="checkbox" label="Untagged scans"
                        style={{ display: "flex", marginRight: "9px", marginLeft: "9px", alignItems: "center" }}
                        id="Untagged"
                        defaultChecked={this.state.untagcheck}
                        onChange={() => this.handleUntagCheck(!(this.state.untagcheck))}

                    />{'  '}
                    <Form.Check type="checkbox" label="Tagged scans"
                        style={{ display: "flex", marginRight: "9px", alignItems: "center" }}
                        id="tagged"
                        defaultChecked={this.state.tagcheck}
                        onChange={() => this.handleTagCheck(!(this.state.tagcheck))}

                    />{'  '}

                    <Form.Check type="checkbox" label="Active scans"
                        style={{ display: "flex", marginRight: "9px", alignItems: "center" }}
                        id="active"
                        defaultChecked={this.state.activecheck}
                        onChange={() => this.handleActiveCheck(!(this.state.activecheck))}

                    />{'  '}
                    <Form.Check type="checkbox" label="Discarded scans"
                        style={{ display: "flex", marginRight: "9px", alignItems: "center" }}
                        id="discarded"
                        defaultChecked={this.state.discardedcheck}
                        onChange={() => this.handleDiscardCheck(!(this.state.discardedcheck))}

                    />{'  '}

                    <Button variant="primary" style={{ float: "right", display: this.state.viewall }} onClick={(e) => this.ViewAllScans()}  > View All Scan(s)</Button>{'   '}

                </div>
                <ViewDetailModal

                    stateProps={this.state}
                    handleClose={this.handleClose}

                />
                <AddCommentModal

                    stateProps={this.state}
                    handleClose={this.handleClose}
                    handleShowCommentModal={this.handleShowCommentModal}
                    UpdateComments={this.UpdateComments}

                />
                <TagScanModal

                    stateProps={this.state}
                    handleClose={this.handleClose}
                    handleShow={this.handleShow}
                    UpdateStudiesTimepoints={this.UpdateStudiesTimepoints}
                />
                <TimeOutNotification
                    sessionState={this.state}

                />
                <ConfirmationModal
                    stateProps={this.state}
                    handleClose={this.handleClose}
                    handleShowConfirmationModal={this.handleShowConfirmationModal}
                    handleShowUndiscardConfirmationModal={this.handleShowUndiscardConfirmationModal}
                    DiscardScans={this.DiscardScans}
                    UnDiscardScans={this.UnDiscardScans}
                />
                <BootstrapTable bootstrap4 keyField='id' data={this.state.filterdata} columns={columns} filter={filterFactory()} pagination={paginationFactory({ sizePerPage: 20 })} striped selectRow={selectRow} defaultSorted={defaultSorted} rowClasses={rowClasses} id="scanTable" />
                <div style={{ marginTop: "-45px", textAlign: "center", position: "relative", marginLeft: "30%", marginRight: "30%" }}><i style={{ marginTop: "5px" }}>powered by </i><a href="https://www.snac.com.au " target="_blank" rel="noopener noreferrer"><img src={poweredByImg} alt="" height="32px" /></a></div>
                <div style={{ marginTop: "-13px", textAlign: "center", marginLeft: "30%", marginRight: "30%" }}><i style={{ color: "grey", fontSize: "x-small", marginRight: "85px" }} >V : {packageJson.version}</i></div>
            </div>
        );
    }

    getAllScans() {
        $("#scanTable").find("th:contains(Id)").hide();
        this.setState({
            loading: false
        }, () =>
            console.log(this.state));

        // Get study id-name lookup
        $.ajax({
            url: '/ScanFilter/GetAssignedStudiesDropdown',
            type: 'GET',
            dataType: 'JSON',
            data: { username: this.state.userName },
            success: function (data) {
                var studyNameLookup = {};
                for (const item of data) {
                    studyNameLookup[item.id] = item.studyName;
                }
                this.setState({
                    studyNameLookup: studyNameLookup,
                });
                this.startSessionTimeoutCounter();
            }.bind(this)
        });

        $.ajax({
            url: '/ScanFilter/GetAllScansByToranaClientId',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                userName: this.state.userName,
                basedOnCreatedTime: this.state.byCreated,
                startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
            },
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {
                $("#loader").removeClass('hidden')
            },
            complete: function () {
                $('#loader').addClass('hidden')
            },
            success: function (data) {
                this.setState({
                    scandata: data, filterdata: data, loading: false
                }, () => this.filterDataBasedOnCheckboxes());
            }.bind(this)
        });
    }
    getUntaggedScans() {
        $("#scanTable").find("th:contains(Id)").hide();
        this.setState({
            loading: false
        }, () =>
            console.log(this.state));

        $.ajax({
            url: '/ScanFilter/GetUntaggedScansByToranaClientId',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                userName: this.state.userName,
                basedOnCreatedTime: this.state.byCreated,
                startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
            },
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                this.setState({
                    filterdata: data, loading: false
                }, () => this.getAllScans());
            }.bind(this)
        });
    }
    getScanBasedonScanDtoId() {
        $("#scanTable").find("th:contains(Id)").hide();
        // Get study id-name lookup
        $.ajax({
            url: '/ScanFilter/GetAssignedStudiesDropdown',
            type: 'GET',
            dataType: 'JSON',
            data: { username: this.state.userName },
            success: function (data) {
                var studyNameLookup = {};
                for (const item of data) {
                    studyNameLookup[item.id] = item.studyName;
                }
                this.setState({
                    studyNameLookup: studyNameLookup,
                });
                this.startSessionTimeoutCounter();
            }.bind(this)
        });

        $.ajax({
            url: '/ScanFilter/GetScanByScanTagDtoId',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                userName: this.state.userName,
                scanTagDtoId: window.localStorage.getItem('scandtoId'),
                basedOnCreatedTime: this.state.byCreated,
                startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
            },
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                this.setState({
                    scandata: data, filterdata: data, viewall: "block", tagcheck: true, untagcheck: true,
                });
                $("#tagged").prop('checked', true);
                $("#untagged").prop('checked', true);
                if (data[0].discarded === true) {
                    $("#discarded").prop('checked', true);
                    $("#active").prop('checked', false
                    );
                    this.setState({
                        discardedcheck: true, activecheck: false
                    });
                }
                else {
                    $("#active").prop('checked', true);
                }
            }.bind(this)
        });
    }
    ConfirmUpdateExamForm(file, scanDtoID) {
        var fd = new FormData();
        fd.append('examForm', file);
        fd.append('scanDtoId', scanDtoID.id);
        fd.append('userName', this.state.userName);
        fd.append('emailRequest', this.state.scanDtoIdEmailRequest);
        $.ajax({
            async: true,
            crossDomain: true,
            url: "/ScanFilter/UpdateExamForm",
            method: "POST",
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            data: fd,
            beforeSend: function () {
                $("#loader").removeClass('hidden')
            },
            complete: function () {
                $('#loader').addClass('hidden')
            },

            success: function (data) {
                var scandata = JSON.parse(data);
                this.setState({
                    scandata: scandata, loading: true
                }, () => this.filterDataBasedOnCheckboxes());
            }.bind(this)
        }).done(function (response) {
        });
    }

    UpdateComments() {
        var comment = $("#comments").val();
        $.ajax({
            url: '/ScanFilter/UpdateComments',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                comments: comment,
                scanTagDtoId: this.state.scanDto.id,
                userName: this.state.userName,
                emailRequest: this.state.scanDtoIdEmailRequest,
                basedOnCreatedTime: this.state.byCreated,
                startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
            },
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {
                $("#loader").removeClass('hidden')
            },
            complete: function () {
                $('#loader').addClass('hidden')
            },
            success: function (data) {
                this.setState({
                    scandata: data, loading: true
                }, () => this.filterDataBasedOnCheckboxes());
            }.bind(this)
        });
    }

    UpdateStudiesTimepoints() {
        var Tags = [];
        $("td").find(".drpstudies").each(function () {
            var StudyId = $(this).val();
            var Timepoint = $(this).closest("tr").find(".drptimepoints").val();
            if (Timepoint === "Other") {
                Timepoint = $(this).closest("tr").find(".txtTimepoint").val();
            }

            Tags.push({
                Key: StudyId,
                Value: Timepoint
            });
        });
        var validate = false;
        // First Time Tag Scan
        if (this.state.scanDto.studyTimepointLookup == null) {
            validate = true;
        }
        // Update Tag Scan
        else {
            var oldTimepointLookup = Object.keys(this.state.scanDto.studyTimepointLookup).map(key => ({
                Key: key,
                Value: this.state.scanDto.studyTimepointLookup[key]
            }));
            if (JSON.stringify(Tags) !== JSON.stringify(oldTimepointLookup))
                validate = true;
        }

        if (validate === true) {
            $.ajax({
                url: '/ScanFilter/UpdateStudiesTimepoints',
                type: 'GET',
                dataType: 'JSON',
                async: true,
                data: {
                    selectedStudyTimepoints: JSON.stringify(Tags),
                    scanTagDtoId: this.state.scanDto.id,
                    userName: this.state.userName,
                    emailRequest: this.state.scanDtoIdEmailRequest,
                    basedOnCreatedTime: this.state.byCreated,
                    startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                    endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
                },
                contentType: "application/json; charset=utf-8",
                beforeSend: function () {
                    $("#loader").removeClass('hidden')
                },
                complete: function () {
                    $('#loader').addClass('hidden')
                },
                success: function (data) {
                    this.setState({
                        scandata: data, loading: true
                    }, () => this.filterDataBasedOnCheckboxes());
                }.bind(this)
            });
        }
    }

    DiscardScans() {
        var scansToDiscard = []

        $('.selectCheckbox').each(function () {
            var value = $(this).find('.scanDtoID').text();
            scansToDiscard.push(value);
        });
        $.ajax({
            url: '/ScanFilter/DiscardScans',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                selectedIds: JSON.stringify(scansToDiscard),
                userName: this.state.userName,
                emailRequest: this.state.scanDtoIdEmailRequest,
                basedOnCreatedTime: this.state.byCreated,
                startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
            },
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {
                $("#loader").removeClass('hidden')
            },
            complete: function () {
                $('#loader').addClass('hidden')
            },
            success: function (data) {
                this.setState({
                    scandata: data, loading: true
                }, () => this.filterDataBasedOnCheckboxes());
            }.bind(this)
        });
    }

    UnDiscardScans() {
        var scansToUnDiscard = []

        $('.selectCheckbox').each(function () {
            var value = $(this).find('.scanDtoID').text();
            scansToUnDiscard.push(value);
        });
        $.ajax({
            url: '/ScanFilter/UnDiscardScans',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                selectedIds: JSON.stringify(scansToUnDiscard),
                userName: this.state.userName,
                emailRequest: this.state.scanDtoIdEmailRequest,
                basedOnCreatedTime: this.state.byCreated,
                startDate: moment(this.state.value[0]).format("YYYY-MM-DD"),
                endDate: moment(this.state.value[1]).format("YYYY-MM-DD")
            },
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {
                $("#loader").removeClass('hidden')
            },
            complete: function () {
                $('#loader').addClass('hidden')
            },
            success: function (data) {
                this.setState({
                    scandata: data, loading: true, checkboxSelection: []
                }, () => this.filterDataBasedOnCheckboxes());
            }.bind(this)
        });
    }

    DownloadFile() {
        $.ajax({
            url: '/ScanFilter/DownloadExamForm',
            type: 'GET',

            async: true,
            data: {
                scanDtoId: this.state.Id
            },
            success: function (data) {
                var link = document.createElement('a');
                link.href = "data:image/" + data.fileFormat.replace(".", "") + ";base64," + data.file;
                link.target = "_blank";
                link.download = this.state.Id + data.fileFormat;
                link.click();
            }.bind(this)
        });
    }
}